import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./CardInfoBox.module.css";
import classNames from "classnames";

/*
 * Used to input info about a card. Can have a label or an image in place of label.
 */

export function CardInfoBox({
  value,
  label,
  img,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  className,
  isValid,
  disabled, // Add disabled prop
}) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  const handleBlur = useCallback(
    debounce((e) => {
      setIsFocused(false);
      if (onBlur) {
        onBlur(e);
      }
    }, 300),
    [onBlur]
  );

  const containerClass = classNames({
    [styles.containerValid]: isValid,
    [styles.containerDefault]: isValid === null,
    [styles.containerError]: isValid === false,
    [styles.containerFocused]: isFocused,
    [styles.container]: true,
  });

  return (
    <div className={styles.container}>
      <div className={classNames(styles.card, containerClass)}>
        {label ? (
          <label className={styles.label}>{label}</label>
        ) : (
          <div className={styles.image}>
            <img src={img} alt="Label" />
          </div>
        )}

        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={className}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

CardInfoBox.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  img: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool, // Add prop type for disabled
};
